// extracted by mini-css-extract-plugin
export default {"custom-colors":"custom-colors__JgXaF","__view-primary":"__view-primary___q2bI","__view-primary-on-color":"__view-primary-on-color__ZEbNq"};